<template>
  <div class="page-wrap">
    <!-- PART 1 — HERO -->
    <section class="hero">
      <div class="hero-bg-ph">
        <img :src="`${imgUrlPrefix}main.jpg`" class="hero-bg" alt="" @error="$event.target.style.display='none'">
      </div>
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <!-- <div class="status-badge">
          <div class="status-dot"></div>
          <span class="status-text">正在进行</span>
        </div> -->
        <div class="eyebrow">Events · Offline</div>
        <h1 class="hero-title">巴丹100 / T3<br>越野挑战赛事</h1>
        <p class="hero-body">
          穿越巴丹吉林沙漠，全程 100 公里，<br>
          T3 组别，真实赛道，实时计时。<br>
          线上报名，线下出发，积分全球排名。
        </p>
        <div class="hero-btns">
          <button class="btn-dark">了解更多 →</button>
          <!-- <button class="btn-border">了解赛制</button> -->
        </div>
        <!-- <div class="hero-data">
          <div class="data-strip">
            <div class="data-item" v-for="(item, idx) in heroStats" :key="idx">
              <div class="data-val">{{ item.val }}</div>
              <div class="data-lbl">{{ item.lbl }}</div>
            </div>
          </div>
        </div> -->
      </div>
    </section>

    <!--  PART 2 — SECOND EVENT -->
    <section class="second-event">
      <div class="event-card">
        <div class="event-left">
          <div class="eyebrow">Events · Online</div>
          <h2>巴丹100 / T3 线上挑战赛事</h2>
          <p class="body-text">
            报名通道开放中，与上百位越野爱好者同场竞技。
          </p>
          <div style="margin-top:32px;">
            <button class="btn-dark">查看详情 →</button>
          </div>
          <!-- <div class="data-strip-sm" style="margin-top:40px;">
            <div v-for="(stat, idx) in secondEventStats" :key="idx">
              <div class="data-val-sm">{{ stat.val }}</div>
              <div class="data-lbl-sm">{{ stat.lbl }}</div>
            </div>
          </div> -->
        </div>
        <div class="event-right">
          <img :src="`${imgUrlPrefix}events_online.jpg`" alt="Badain 100 Round 2" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
          <div class="img-ph" style="display:none;"><span>Badain100 · Round 2</span></div>
        </div>
      </div>
    </section>

    <!--  PART 3 — GAME MODES INTRO -->
    <section class="modes-intro">
      <div class="eyebrow">Beyond The Track</div>
      <h2>赛事不只在赛道上</h2>
      <p>
        六种赛事模式，从真实越野到数字孪生，<br>
        从个人挑战到城市共建。<br>
        找到属于你的竞技方式。
      </p>
    </section>

    <!--  PART 6 — RALLY RACING -->
    <section class="rally">
      <div class="rally-left">
        <img :src="`${imgUrlPrefix}RallyRacting.jpg`" alt="Rally" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
        <div class="img-ph" style="display:none;"><span>Rally Racing</span></div>
        <div class="rally-float">
          <div class="rally-big-num">231</div>
          <div class="rally-big-label">当前参赛组数</div>
        </div>
      </div>
      <div class="rally-right">
        <div class="eyebrow">Game Mode · 01</div>
        <h2>Rally Racing</h2>
        <p class="body-text">
          真实赛段模拟，计时赛制，<br>
          全球玩家同台竞技。<br>
          你的每一秒都会被记录。
        </p>
        <div class="data-strip-sm" style="margin-top:32px;">
          <div v-for="(stat, idx) in rallyStats" :key="idx">
            <div class="data-val-sm">{{ stat.val }}</div>
            <div class="data-lbl-sm">{{ stat.lbl }}</div>
          </div>
        </div>
        <div style="margin-top:32px;">
          <button class="btn-dark">了解更多 →</button>
        </div>
      </div>
    </section>

    <!--  PART 4 — GAMEPLAY -->
    <section class="gameplay">
      <div class="gameplay-left">
        <div class="eyebrow">Game Mode · 02</div>
        <h2>Gameplay</h2>
        <p class="body-text">
          在数字化的巴丹吉林地图上，<br>
          以第一视角驾驶完成任务。<br>
          积分、排名、限时挑战，<br>
          打破虚实边界的竞技体验。
        </p>
        <div class="feature-list">
          <div class="feature-item" v-for="(feat, idx) in gameplayFeatures" :key="idx">
            <div class="feature-line"></div>
            <span class="feature-text">{{ feat }}</span>
          </div>
        </div>
        <div style="margin-top:36px;">
          <button class="btn-dark">了解更多 →</button>
        </div>
      </div>
      <div class="gameplay-right">
        <img :src="`${imgUrlPrefix}Gameplay.jpg`" alt="Gameplay" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
        <div class="img-ph" style="display:none;"><span>Gameplay</span></div>
        <div class="hud-card">
          <div class="hud-minimap">
            <svg width="130" height="90" viewBox="0 0 130 90" fill="none" xmlns="http://www.w3.org/2000/svg">
              <polyline points="15,75 30,55 50,60 70,40 90,45 110,25 118,30"
                stroke="#080808" stroke-width="1.5" stroke-opacity="0.2" fill="none" stroke-linejoin="round"/>
              <circle cx="90" cy="45" r="3" fill="#080808"/>
            </svg>
          </div>
          <div class="hud-data">
            Player &nbsp;· &nbsp;METTA-7743<br>
            Rank &nbsp;&nbsp;&nbsp;· &nbsp;#14 / 231<br>
            Time &nbsp;&nbsp;&nbsp;· &nbsp;00:42:17
          </div>
        </div>
      </div>
    </section>

    <!-- PART 5 — OFF-ROAD STIMULATION -->
    <section class="offroad">
      <img class="bg" :src="`${imgUrlPrefix}off-road-stimulation.jpg`" alt="Off-Road" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
      <div class="img-ph bg" style="display:none;"><span>Off-Road Stimulation</span></div>
      <div class="offroad-overlay"></div>
      <div class="offroad-content">
        <div class="eyebrow">Game Mode · 03</div>
        <h2>Off-Road<br>Stimulation</h2>
        <p class="body-text">
          真实物理引擎模拟越野驾驶，<br>
          地形、悬挂、轮胎抓地力全部还原。<br>
          在屏幕前感受巴丹吉林的每一块石头。
        </p>
        <div style="margin-top:32px;">
          <button class="btn-dark">了解更多 →</button>
        </div>
      </div>
    </section>

    <!-- PART 7 — MOD -->
    <section class="mod-section">
      <div class="mod-left">
        <div class="eyebrow">Game Mode · 04</div>
        <h2>MOD</h2>
        <p class="body-text">
          在数字世界里改装你的载具。<br>
          每一次改装都能生成真实配置清单，<br>
          可一键同步至实车定制系统。
        </p>
        <div class="icon-row">
          <div class="icon-box" v-for="(icon, idx) in modIcons" :key="idx" v-html="icon"></div>
        </div>
        <div style="margin-top:28px;">
          <button class="btn-dark">开始改装 →</button>
        </div>
      </div>
      <div class="mod-right">
        <img :src="`${imgUrlPrefix}MOD.jpg`" alt="MOD" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
        <div class="img-ph" style="display:none;"><span>Customizable MOD</span></div>
      </div>
    </section>

    <!-- PART 8 — TOWN BUILDING -->
    <section class="town">
      <div class="town-header">
        <div class="eyebrow">Game Mode · 05</div>
        <h2>Town Building</h2>
        <p>
          在 METTA 宇宙中建造你的城镇。<br>
          选择地形、规划道路、布置建筑，<br>
          每座小镇都是一个独立的赛事生态。
        </p>
      </div>
      <img :src="`${imgUrlPrefix}town_building.jpg`" class="town-img" alt="Town Building" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
      <div class="town-img-ph" style="display:none;"><span>Town Building</span></div>
      <div class="town-cards">
        <div class="town-card" v-for="(card, idx) in townCards" :key="idx">
          <h3>{{ card.title }}</h3>
          <p>{{ card.desc }}</p>
        </div>
      </div>
    </section>

    <!-- PART 9 — AI TOWN -->
    <section class="ai-town">
      <div class="ai-left">
        <img :src="`${imgUrlPrefix}AI_town.jpg`" alt="AI Town" @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
        <div class="img-ph" style="display:none;"><span>AI Town</span></div>
      </div>
      <div class="ai-right">
        <div class="eyebrow">Game Mode · 06</div>
        <h2>AI Town</h2>
        <p class="body-text">
          由 AI 驱动的动态城镇，<br>
          会随着玩家行为不断进化。<br>
          超过 12,345 名 AI 居民，<br>
          无限接近真实世界的数字生态。
        </p>
        <div class="data-strip-sm" style="margin-top:32px;">
          <div v-for="(stat, idx) in aiStats" :key="idx">
            <div class="data-val-sm">{{ stat.val }}</div>
            <div class="data-lbl-sm">{{ stat.lbl }}</div>
          </div>
        </div>
        <div style="margin-top:32px;">
          <button class="btn-dark">探索 AI 小镇 →</button>
        </div>
      </div>
    </section>

    <!-- PART 10 — CREATE YOUR EVENT -->
    <section class="create-event">
      <h2>发起你自己的赛事</h2>
      <p>
        任何人都可以成为赛事发起者。<br>
        设定规则、邀请参与者、颁发奖励。<br>
        你的赛事，你的规则。
      </p>
      <div class="create-btns">
        <button class="btn-white">创建赛事 →</button>
        <button class="btn-ghost-wh">浏览赛事</button>
      </div>
      <div class="create-micro">已有 2,847 场赛事正在进行</div>
    </section>

    <!-- <footer>
      <div class="ft-logo">
        <img :src="`${imgUrlPrefix}logo-m.svg`" @error="$event.target.style.display='none'" alt="M">
        Metta · Events
      </div>
      <div class="ft-copy">© 2026 Metta · All Rights Reserved</div>
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'EventsPage',
  data() {
    return {
      imgUrlPrefix: '/assets/images/events/', // 图片地址前缀
      heroStats: [
        { val: '2026.06.15', lbl: '报名截止' },
        { val: '内蒙古·阿拉善', lbl: '赛事地点' },
        { val: '231 组', lbl: '已报名' },
      ],
      secondEventStats: [
        { val: '2026.07.20', lbl: '赛事日期' },
        { val: 'T3 / T4', lbl: '组别' },
        { val: '限 50 组', lbl: '名额' },
      ],
      gameplayFeatures: [
        '实时多人对战',
        '全球排行榜',
        '赛季限定奖励',
      ],
      rallyStats: [
        // { val: '320km', lbl: '赛道长度' },
        { val: '实时同步', lbl: '赛季积分' },
      ],
      modIcons: [
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M13 3C13 3 14 4 14 6C14 8 12 9 12 9L5 16L4 16L4 15L11 8C11 8 12 6 12 5C12 4 13 3 13 3Z" stroke="#a6a6a4" stroke-width="1" fill="none" stroke-linejoin="round"/><circle cx="5" cy="15" r="1.5" stroke="#a6a6a4" stroke-width="1" fill="none"/></svg>',
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="7" stroke="#a6a6a4" stroke-width="1" fill="none"/><circle cx="10" cy="10" r="2.5" stroke="#a6a6a4" stroke-width="1" fill="none"/><line x1="10" y1="3" x2="10" y2="7.5" stroke="#a6a6a4" stroke-width="1"/><line x1="10" y1="12.5" x2="10" y2="17" stroke="#a6a6a4" stroke-width="1"/><line x1="3" y1="10" x2="7.5" y2="10" stroke="#a6a6a4" stroke-width="1"/><line x1="12.5" y1="10" x2="17" y2="10" stroke="#a6a6a4" stroke-width="1"/></svg>',
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="4" y="5" width="8" height="9" rx="0" stroke="#a6a6a4" stroke-width="1" fill="none"/><path d="M8 5L11 2L14 5" stroke="#a6a6a4" stroke-width="1" fill="none" stroke-linejoin="round"/><circle cx="15.5" cy="14.5" r="2" stroke="#a6a6a4" stroke-width="1" fill="none"/><line x1="14" y1="5" x2="15.5" y2="12.5" stroke="#a6a6a4" stroke-width="1"/></svg>',
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="2.5" stroke="#a6a6a4" stroke-width="1" fill="none"/><path d="M10 2.5L10 4.5M10 15.5L10 17.5M2.5 10L4.5 10M15.5 10L17.5 10M4.4 4.4L5.8 5.8M14.2 14.2L15.6 15.6M15.6 4.4L14.2 5.8M5.8 14.2L4.4 15.6" stroke="#a6a6a4" stroke-width="1" stroke-linecap="round"/><circle cx="10" cy="10" r="5" stroke="#a6a6a4" stroke-width="1" stroke-dasharray="2 2" fill="none"/></svg>',
      ],
      townCards: [
        { title: '自由建造', desc: '自定义地形与建筑布局' },
        { title: '赛事举办', desc: '在小镇中举办专属赛事' },
        { title: '社区共享', desc: '开放给全球玩家探索' },
      ],
      aiStats: [
        // { val: '12,345+', lbl: 'AI 居民' },
        { val: '每日更新', lbl: '动态事件' },
      ],
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
.page-wrap {
  // 通用
  .eyebrow {
    font-size: 9px; letter-spacing: 4px; text-transform: uppercase;
    color: @mute; font-weight: 300;
  }
  .img-ph {
    width: 100%; height: 100%;
    background: #d8d5d0;
    display: flex; align-items: center; justify-content: center;
    span { font-size: 9px; letter-spacing: 3px; text-transform: uppercase; color: rgba(0,0,0,0.18); }
  }
  .btn-dark {
    display: inline-block;
    font-size: 9px; letter-spacing: 2px; text-transform: uppercase;
    color: @bg; background: @ink; border: 1px solid @ink;
    padding: 14px 32px; font-family: inherit; font-weight: 300; cursor: pointer;
    transition: opacity .15s;
    &:hover { opacity: .8; }
  }
  .btn-border {
    display: inline-block;
    font-size: 9px; letter-spacing: 2px; text-transform: uppercase;
    color: @ink; background: transparent; border: 1px solid @bdr;
    padding: 14px 32px; font-family: inherit; font-weight: 300; cursor: pointer;
    transition: border-color .15s;
    &:hover { border-color: @ink; }
  }
  .data-strip { display: flex; gap: 40px; }
  .data-val { font-size: 20px; font-weight: 100; color: @ink; line-height: 1; }
  .data-lbl { font-size: 8px; letter-spacing: 2px; text-transform: uppercase; color: @mute; margin-top: 4px; }
  .data-strip-sm { display: flex; gap: 32px; }
  .data-val-sm { font-size: 18px; font-weight: 100; color: @ink; line-height: 1; }
  .data-lbl-sm { font-size: 8px; letter-spacing: 2px; text-transform: uppercase; color: @mute; margin-top: 3px; }

  // PART 1 — HERO
  .hero {
    min-height: 80vh;
    position: relative; overflow: hidden;
    display: flex; align-items: center;
    padding-top: 52px;
    background: #1a1612;
  }
  .hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover;
  }
  .hero-bg-ph {
    position: absolute; inset: 0;
    background: linear-gradient(135deg, #2a2218 0%, #1a1410 100%);
  }
  .hero-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(to right, rgba(247,247,245,0.95) 45%, rgba(247,247,245,0.2) 100%);
  }
  .hero-content {
    position: relative; z-index: 2;
    padding: 80px 64px;
    max-width: 580px;
  }
  .status-badge {
    display: flex; align-items: center; gap: 8px;
    margin-bottom: 24px;
    .status-dot {
      width: 6px; height: 6px; border-radius: 50%;
      background: #22c55e; flex-shrink: 0;
    }
    .status-text {
      font-size: 9px; letter-spacing: 3px; text-transform: uppercase; color: @mid;
    }
  }
  .hero-content .eyebrow { margin-bottom: 0; }
  .hero-title {
    font-size: 52px; font-weight: 100; color: @ink;
    letter-spacing: -2px; line-height: 1.05; margin-top: 12px;
  }
  .hero-body {
    font-size: 13px; line-height: 2; color: @mid; margin-top: 24px;
  }
  .hero-btns { display: flex; gap: 12px; margin-top: 36px; }
  .hero-data { margin-top: 56px; }

  
  // PART 2 — SECOND EVENT
  .second-event {
    background: @bg;
    padding: 0 44px 80px;
  }
  .event-card {
    border: 1px solid @bdr;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .event-left {
    background: #efefed;
    padding: 48px 56px;
    display: flex; flex-direction: column; justify-content: center;
    .eyebrow { margin-bottom: 16px; }
    h2 { font-size: 30px; font-weight: 100; line-height: 1.2; color: @ink; }
    .body-text { font-size: 13px; color: @mid; line-height: 2; margin-top: 20px; }
  }
  .event-right {
    position: relative; overflow: hidden;
    min-height: 400px;
    img, .img-ph {
      position: absolute; inset: 0;
      width: 100%; height: 100%; object-fit: cover;
    }
  }

  // PART 3 — GAME MODES INTRO
  .modes-intro {
    background: @bg;
    padding: 100px 44px;
    text-align: center;
    border-top: 1px solid @bdr;
    .eyebrow { margin-bottom: 16px; }
    h2 { font-size: 44px; font-weight: 100; letter-spacing: -2px; color: @ink; }
    p { font-size: 13px; color: @mid; max-width: 480px; margin: 20px auto 0; line-height: 2; }
  }

  // PART 4 — GAMEPLAY
  .gameplay {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    min-height: 560px;
    border-top: 1px solid @bdr;
  }
  .gameplay-left {
    background: @bg;
    padding: 64px 56px;
    display: flex; flex-direction: column; justify-content: center;
    .eyebrow { margin-bottom: 16px; }
    h2 { font-size: 38px; font-weight: 100; letter-spacing: -1px; color: @ink; }
    .body-text { font-size: 13px; color: @mid; line-height: 2; margin-top: 20px; }
  }
  .feature-list { margin-top: 32px; display: flex; flex-direction: column; gap: 10px; }
  .feature-item { display: flex; align-items: center; gap: 12px; }
  .feature-line { width: 1px; height: 16px; background: @bdr; flex-shrink: 0; }
  .feature-text { font-size: 10px; letter-spacing: 1.5px; color: @mid; }

  .gameplay-right {
    position: relative; overflow: hidden;
    img, .img-ph {
      position: absolute; inset: 0;
      width: 100%; height: 100%; object-fit: cover;
    }
  }
  .hud-card {
    position: absolute; top: 24px; right: 24px; z-index: 2;
    background: @glass;
    backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255,255,255,0.6);
    padding: 16px 20px;
  }
  .hud-minimap {
    width: 130px; height: 90px;
    background: #e8e6e3;
    margin-bottom: 12px;
    position: relative; overflow: hidden;
  }
  .hud-data {
    font-size: 8px; letter-spacing: 2px; text-transform: uppercase;
    color: @mute; line-height: 2;
    font-family: 'Roboto Mono', monospace;
  }

  // PART 5 — OFF-ROAD STIMULATION
  .offroad {
    position: relative; height: 580px;
    border-top: 1px solid @bdr;
    overflow: hidden;
    img.bg, .img-ph.bg {
      position: absolute; inset: 0;
      width: 100%; height: 100%; object-fit: cover;
    }
  }
  .offroad-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(to left, rgba(247,247,245,0.92) 35%, rgba(247,247,245,0.1) 100%);
  }
  .offroad-content {
    position: absolute; right: 0; top: 0; bottom: 0;
    width: 40%; padding: 64px;
    display: flex; flex-direction: column; justify-content: center;
    z-index: 2;
    .eyebrow { margin-bottom: 16px; }
    h2 { font-size: 38px; font-weight: 100; letter-spacing: -1px; line-height: 1.1; color: @ink; }
    .body-text { font-size: 13px; color: @mid; line-height: 2; margin-top: 20px; }
  }

  // PART 6 — RALLY RACING
  .rally {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    min-height: 560px;
    border-top: 1px solid @bdr;
  }
  .rally-left {
    position: relative; overflow: hidden;
    img, .img-ph {
      position: absolute; inset: 0;
      width: 100%; height: 100%; object-fit: cover;
    }
  }
  .rally-float {
    position: absolute; top: 40px; left: 40px; z-index: 2;
    pointer-events: none;
  }
  .rally-big-num {
    font-size: 120px; font-weight: 100;
    color: rgba(8,8,8,0.06); letter-spacing: -8px; line-height: 1;
  }
  .rally-big-label {
    font-size: 9px; letter-spacing: 3px; text-transform: uppercase;
    color: rgba(8,8,8,0.25); margin-top: -16px;
  }
  .rally-right {
    background: #efefed;
    padding: 64px;
    display: flex; flex-direction: column; justify-content: center;
    .eyebrow { margin-bottom: 16px; }
    h2 { font-size: 38px; font-weight: 100; letter-spacing: -1px; color: @ink; }
    .body-text { font-size: 13px; color: @mid; line-height: 2; margin-top: 20px; }
  }

  // PART 7 — MOD
  .mod-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 520px;
    border-top: 1px solid @bdr;
  }
  .mod-left {
    background: @bg;
    padding: 64px 56px;
    display: flex; flex-direction: column; justify-content: center;
    .eyebrow { margin-bottom: 16px; }
    h2 { font-size: 38px; font-weight: 100; letter-spacing: -1px; line-height: 1.1; color: @ink; }
    .body-text { font-size: 13px; color: @mid; line-height: 2; margin-top: 20px; }
  }
  .icon-row { display: flex; gap: 12px; margin-top: 28px; }
  .icon-box {
    width: 44px; height: 44px;
    background: #efefed; border: 1px solid @bdr;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }
  .mod-right {
    position: relative; overflow: hidden;
    min-height: 480px;
    img, .img-ph {
      position: absolute; inset: 0;
      width: 100%; height: 100%; object-fit: cover;
    }
  }

  // PART 8 — TOWN BUILDING
  .town {
    background: #efefed;
    padding: 80px 44px;
    border-top: 1px solid @bdr;
  }
  .town-header { text-align: center; margin-bottom: 56px; }
  .town-header .eyebrow { margin-bottom: 16px; }
  .town-header h2 { font-size: 44px; font-weight: 100; letter-spacing: -2px; color: @ink; }
  .town-header p { font-size: 13px; color: @mid; max-width: 480px; margin: 16px auto 0; line-height: 2; }
  
  .town-img {
    width: 100%; height: 440px; object-fit: cover; display: block;
    background: #d0cdc8;
  }
  .town-img-ph { 
    width: 100%; height: 440px; background: #d0cdc8; 
    display: flex; align-items: center; justify-content: center; 
  }
  
  .town-cards {
    display: grid; grid-template-columns: repeat(3, 1fr);
    gap: 1px; background: @bdr; margin-top: 24px;
  }
  .town-card {
    background: @bg; padding: 28px 32px;
    h3 { font-size: 14px; font-weight: 300; color: @ink; }
    p { font-size: 11px; color: @mute; line-height: 1.9; margin-top: 8px; }
  }

  // PART 9 — AI TOWN
  .ai-town {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 520px;
    border-top: 1px solid @bdr;
  }
  .ai-left {
    position: relative; overflow: hidden;
    img, .img-ph {
      position: absolute; inset: 0;
      width: 100%; height: 100%; object-fit: cover;
    }
  }
  .ai-right {
    background: @bg;
    padding: 64px;
    display: flex; flex-direction: column; justify-content: center;
    .eyebrow { margin-bottom: 16px; }
    h2 { font-size: 38px; font-weight: 100; letter-spacing: -1px; color: @ink; }
    .body-text { font-size: 13px; color: @mid; line-height: 2; margin-top: 20px; }
  }

  // PART 10 — CREATE YOUR EVENT
  .create-event {
    background: @ink;
    padding: 100px 44px;
    text-align: center;
    border-top: 1px solid #1c1c1a;
    h2 {
      font-size: 52px; font-weight: 100; color: white;
      letter-spacing: -2px;
    }
    p {
      font-size: 13px; color: rgba(255,255,255,0.4);
      max-width: 480px; margin: 24px auto 0; line-height: 2;
    }
  }
  .create-btns { display: flex; gap: 16px; justify-content: center; margin-top: 40px; }
  .btn-white {
    font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
    color: @ink; background: white; border: 1px solid white;
    padding: 16px 40px; font-family: inherit; font-weight: 300; cursor: pointer;
    transition: opacity .15s;
    &:hover { opacity: .85; }
  }
  .btn-ghost-wh {
    font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
    color: white; background: transparent;
    border: 1px solid rgba(255,255,255,0.2);
    padding: 16px 40px; font-family: inherit; font-weight: 300; cursor: pointer;
    transition: border-color .15s;
    &:hover { border-color: rgba(255,255,255,0.5); }
  }
  .create-micro {
    margin-top: 48px;
    font-size: 9px; letter-spacing: 3px; text-transform: uppercase;
    color: rgba(255,255,255,0.2);
  }

  // FOOTER
  footer {
    padding: 48px 44px;
    border-top: 1px solid rgba(255,255,255,0.06);
    background: @ink;
    display: flex; align-items: center; justify-content: space-between;
  }
  .ft-logo { 
    display: flex; align-items: center; gap: 8px; 
    font-size: 11px; letter-spacing: 5px; text-transform: uppercase; 
    color: rgba(255,255,255,0.2); 
    img { height: 12px; opacity: .2; }
  }
  .ft-copy { font-size: 8.5px; letter-spacing: 2px; text-transform: uppercase; color: rgba(255,255,255,0.12); }
}
</style>